import {
  Emoji,
  CLIENT_VIEWS,
  ALERT_VIEWS,
  PATCH_VIEWS,
  MAILBOX_VIEWS,
  QUOTE_VIEWS,
  QUOTE_VIEWS_CLIENT
} from '@nile/components';
import { SVGIcon } from '@superops/super-icons';
import React from 'react';

const VIEWS = {
  TASK: 'task',
  TICKET: 'ticket',
  PROJECT: 'project',
  INVOICE: 'INVOICE'
};

const getEmoji = (el) => {
  switch (el?.id) {
    case QUOTE_VIEWS.all:
    case QUOTE_VIEWS.drafts:
      return (
        <div className="mr12 emoji">
          <Emoji symbol="📄" label="my_quotes" />
        </div>
      );
    case '4':
      return (
        <div className="mr12 emoji">
          <Emoji symbol="🧢" label="my_tasks" />
        </div>
      );
    case '3':
      return (
        <div className="mr12 emoji">
          <Emoji symbol="🗃️" label="all_tasks" />
        </div>
      );
    case '5':
    case '6':
    case '7':
    case '20':
      return (
        <div className="mr12 emoji">
          <Emoji symbol="💼" label="project" />
        </div>
      );
    case '9':
    case '19':
    case '5010':
      return (
        <div className="mr12 emoji">
          <Emoji symbol="🗑️" label="delete" />
        </div>
      );
    case '8':
      return (
        <div className="mr12 emoji">
          <Emoji symbol="⚠️" label="spam" />
        </div>
      );
    case '2':
    case '16':
      return (
        <div className="mr12 emoji">
          <Emoji symbol="🎩" label="my_tickets" />
        </div>
      );
    case 'mail-view':
    case MAILBOX_VIEWS.unknownEmails:
      return (
        <div className="mr12 emoji">
          <Emoji symbol="📮" label="my_mails" />
        </div>
      );
    case '10':
      return (
        <div className="mr12 emoji">
          <Emoji symbol="⏰" label="due_today" />
        </div>
      );
    case '11':
      return (
        <div className="mr12 emoji">
          <Emoji symbol="🗂️" label="group_tickets" />
        </div>
      );
    case '12':
      return (
        <div className="mr12 emoji">
          <Emoji symbol="👣" label="follow" />
        </div>
      );
    case '13':
      return (
        <div className="mr12 emoji">
          <Emoji symbol="👤" label="unassigned" />
        </div>
      );
    case '14':
      return (
        <div className="mr12 emoji">
          <Emoji symbol="🧰" label="group_tasks" />
        </div>
      );
    case '18':
      return (
        <div className="mr12 emoji">
          <Emoji symbol="❓" label="unknown_ticket" />
        </div>
      );
    case CLIENT_VIEWS.activeClients:
      return (
        <div className="mr12 emoji">
          <Emoji symbol="❤️" label="activeClients" />
        </div>
      );
    case CLIENT_VIEWS.allClients:
      return (
        <div className="mr12 emoji">
          <Emoji symbol="🏛️" label="allClients" />
        </div>
      );
    case CLIENT_VIEWS.myClients:
      return (
        <div className="mr12 emoji">
          <Emoji symbol="🏢" label="myClients" />
        </div>
      );
    case CLIENT_VIEWS.prospects:
      return (
        <div className="mr12 emoji">
          <Emoji symbol="💰" label="prospects" />
        </div>
      );
    case CLIENT_VIEWS.trash:
      return (
        <div className="mr12 emoji">
          <Emoji symbol="🗑️" label="trash" />
        </div>
      );
    case CLIENT_VIEWS.contracts:
    case '15':
      return (
        <div className="mr12 emoji">
          <Emoji symbol="📝" label="contracts" />
        </div>
      );
    case CLIENT_VIEWS.invoiceAudit:
    case QUOTE_VIEWS.pending:
    case QUOTE_VIEWS_CLIENT.pending:
    case '17':
      return (
        <div className="mr12 emoji">
          <Emoji symbol="‼️" label="invoiceAudit" />
        </div>
      );
    case CLIENT_VIEWS.approvedItems:
    case QUOTE_VIEWS.approved:
    case QUOTE_VIEWS_CLIENT.approved:
      return (
        <div className="mr12 emoji">
          <Emoji symbol="✅" label="approvedItems" />
        </div>
      );
    case CLIENT_VIEWS.ignoredItems:
    case QUOTE_VIEWS.closed:
    case QUOTE_VIEWS_CLIENT.closed:
      return (
        <div className="mr12 emoji">
          <Emoji symbol="🚫" label="ignoredItems" />
        </div>
      );
    case CLIENT_VIEWS.allInvoices:
      return (
        <div className="mr12 emoji">
          <Emoji symbol="💵" label="allInvoices" />
        </div>
      );
    case CLIENT_VIEWS.overdueInvoices:
      return (
        <div className="mr12 emoji">
          <Emoji symbol="🚨" label="overdueInvoices" />
        </div>
      );
    case CLIENT_VIEWS.unpaidInvoices:
      return (
        <div className="mr12 emoji">
          <Emoji symbol="⚠️" label="unpaidInvoices" />
        </div>
      );
    case CLIENT_VIEWS.recentlyPaidInvoices:
      return (
        <div className="mr12 emoji">
          <Emoji symbol="☑️" label="recentlyPaidInvoices" />
        </div>
      );
    case CLIENT_VIEWS.paidInvoices:
      return (
        <div className="mr12 emoji">
          <Emoji symbol="🧾" label="paidInvoices" />
        </div>
      );
    case CLIENT_VIEWS.invoiceSettings:
    case CLIENT_VIEWS.paymentSettings:
      return (
        <div className="mr12 emoji">
          <Emoji symbol="⚙️" label="invoiceSettings" />
        </div>
      );
    case PATCH_VIEWS.allPatches:
    case PATCH_VIEWS.failedPatches:
    case PATCH_VIEWS.latestPatches:
    case PATCH_VIEWS.pendingApproval:
      return (
        <div className="mr12 emoji">
          <SVGIcon name="PatchLight" size="sm" />
        </div>
      );
    case '4001':
    case '4002':
    case '816469700970196992':
    case '2713747020621058048':
    case '2713772828681080832':
    case '4115357822070145024':
    case '4183126150721880064':
    case '5669185532418547712':
    case '8125313067811041280':
    case '8953927208785244160':
    case '8953927314913718272':
      return (
        <div className="mr12 emoji">
          <SVGIcon name="AssetGroup" size="sm" color="#323232" />
        </div>
      );
    case ALERT_VIEWS.allAlerts:
      return (
        <div className="mr12 emoji">
          <SVGIcon name="AlertIcon" size="sm" />
        </div>
      );
    case MAILBOX_VIEWS.newConversations:
    case MAILBOX_VIEWS.clientNewConversations:
      return (
        <div className="mr12 emoji">
          <Emoji symbol="📨" label="newConversations" />
        </div>
      );
    case MAILBOX_VIEWS.clientCommunications:
      return (
        <div className="mr12 emoji">
          <Emoji symbol="🏛️" label="clientCommunications" />
        </div>
      );
    case MAILBOX_VIEWS.prospectCommunications:
      return (
        <div className="mr12 emoji">
          <Emoji symbol="💰" label="prospectCommunications" />
        </div>
      );
    case MAILBOX_VIEWS.allConversations:
    case MAILBOX_VIEWS.clientAllConversations:
      return (
        <div className="mr12 emoji">
          <Emoji symbol="📬" label="allConversations" />
        </div>
      );
    case MAILBOX_VIEWS.sentEmails:
    case MAILBOX_VIEWS.clienSentEmails:
      return (
        <div className="mr12 emoji">
          <Emoji symbol="🚀" label="sentEmails" />
        </div>
      );
    case 'requester-view':
      return (
        <div className="mr12 emoji">
          <Emoji symbol="🤵" label="requesters" />
        </div>
      );
    case '29':
      return (
        <div className="mr12 emoji">
          <Emoji symbol="⏰" label="my_due_project" />
        </div>
      );
    case '30':
      return (
        <div className="mr12 emoji">
          <Emoji symbol="⏰" label="my_due_task" />
        </div>
      );
    case 'review-queue':
    case 'monica-insights':
      return (
        <div className="mr12 emoji">
          <Emoji symbol={el?.emoji} label="my_due_task" />
        </div>
      );
    default:
      if (el?.section === VIEWS.TASK) {
        return (
          <div className="mr12 emoji">
            <Emoji symbol="📋" label="default_task" />
          </div>
        );
      } else if (el?.section === VIEWS.PROJECT) {
        return (
          <div className="mr12 emoji">
            {// To show Icons from ProjectViews Api if it have, otherwise will defaultIcon
            el.displayIcon !== null ? (
              <Emoji symbol={el.displayIcon} label="default_ticket" />
            ) : (
              <Emoji symbol="🎟️" label="default_ticket" />
            )}
          </div>
        );
      } else if (el?.module === VIEWS.INVOICE || el?.module === 'CLIENT') {
        return (
          <div className="mr12 emoji">
            {// To displayIcons for invoice from if it have, otherwise will defaultIcon
            el.displayIcon !== null ? (
              <Emoji symbol={el.displayIcon} label="default_ticket" />
            ) : (
              <Emoji symbol="🎟️" label="default_ticket" />
            )}
          </div>
        );
      } else {
        return (
          <div className="mr12 emoji">
            <Emoji symbol="🎟️" label="default_ticket" />
          </div>
        );
      }
  }
};

export { getEmoji };
